import { z } from "zod";

const rawEnv = {
  NEXT_PUBLIC_JWT_REFRESH_EXPIRATION_OFFSET:
    process.env.NEXT_PUBLIC_JWT_REFRESH_EXPIRATION_OFFSET,
  NEXT_PUBLIC_PROFILES_PHOTOS_BUCKET_NAME:
    process.env.NEXT_PUBLIC_PROFILES_PHOTOS_BUCKET_NAME,
  NEXT_PUBLIC_LISTINGS_PHOTOS_BUCKET_NAME:
    process.env.NEXT_PUBLIC_LISTINGS_PHOTOS_BUCKET_NAME,
  NEXT_PUBLIC_LISTINGS_VIDEOS_BUCKET_NAME:
    process.env.NEXT_PUBLIC_LISTINGS_VIDEOS_BUCKET_NAME,
  NEXT_PUBLIC_LOCATIONS_PHOTOS_BUCKET_NAME:
    process.env.NEXT_PUBLIC_LOCATIONS_PHOTOS_BUCKET_NAME,
  NEXT_PUBLIC_MEDIA_DISTRIBUTION_URL:
    process.env.NEXT_PUBLIC_MEDIA_DISTRIBUTION_URL,
  NEXT_PUBLIC_LOCATIONS_PHOTOS_DISTRIBUTION_URL:
    process.env.NEXT_PUBLIC_LOCATIONS_PHOTOS_DISTRIBUTION_URL,
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
    process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  NEXT_PUBLIC_RADARPUBLISHABLEKEY: process.env.NEXT_PUBLIC_RADARPUBLISHABLEKEY,
  NEXT_ADMIN_API_URL: process.env.NEXT_ADMIN_API_URL,
  NEXT_AUTH_API_URL: process.env.NEXT_AUTH_API_URL,
  NEXT_ARTICLES_API_URL: process.env.NEXT_ARTICLES_API_URL,
  NEXT_CURRENCY_API_URL: process.env.NEXT_CURRENCY_API_URL,
  NEXT_LISTINGS_API_URL: process.env.NEXT_LISTINGS_API_URL,
  NEXT_LISTINGS_MANAGEMENT_API_URL:
    process.env.NEXT_LISTINGS_MANAGEMENT_API_URL,
  NEXT_SEARCH_API_URL: process.env.NEXT_SEARCH_API_URL,
  NEXT_PROFILES_API_URL: process.env.NEXT_PROFILES_API_URL,
  NEXT_PAYMENTS_API_URL: process.env.NEXT_PAYMENTS_API_URL,
  NEXT_AGENCY_API_URL: process.env.NEXT_AGENCY_API_URL,
  NEXT_SHARED_API_URL: process.env.NEXT_SHARED_API_URL,
  NEXT_NOTIFICATIONS_API_URL: process.env.NEXT_NOTIFICATIONS_API_URL,
  NEXT_CHATS_API_URL: process.env.NEXT_CHATS_API_URL,
  NEXT_CHATS_SOCKET_API_URL: process.env.NEXT_CHATS_SOCKET_API_URL,
  NEXT_DEFAULT_API_URL: process.env.NEXT_DEFAULT_API_URL,
  NEXT_MAP_URL: process.env.NEXT_MAP_URL,
  NEXT_COGNITO_CLIENT_ID: process.env.NEXT_COGNITO_CLIENT_ID,
  NEXT_COGNITO_URL: process.env.NEXT_COGNITO_URL,
  NEXT_PUBLIC_FORCE_SECURE: process.env.NEXT_PUBLIC_FORCE_SECURE,
  NEXT_NOTIFICATIONS_APPSYNC_WSS: process.env.NEXT_NOTIFICATIONS_APPSYNC_WSS,
  NEXT_NOTIFICATIONS_GRAPHQL_HOST: process.env.NEXT_NOTIFICATIONS_GRAPHQL_HOST,
};

const schema = z.object({
  NEXT_PUBLIC_JWT_REFRESH_EXPIRATION_OFFSET: z
    .string()
    .min(1, "Missing refresh"),
  NEXT_PUBLIC_PROFILES_PHOTOS_BUCKET_NAME: z
    .string()
    .min(1, "Missing profiles photos bucket name"),
  NEXT_PUBLIC_LISTINGS_PHOTOS_BUCKET_NAME: z
    .string()
    .min(1, "Missing listings photos bucket name"),
  NEXT_PUBLIC_LISTINGS_VIDEOS_BUCKET_NAME: z
    .string()
    .min(1, "Missing listings photos bucket name"),
  NEXT_PUBLIC_LOCATIONS_PHOTOS_BUCKET_NAME: z
    .string()
    .min(1, "Missing locations photos bucket name"),
  NEXT_PUBLIC_MEDIA_DISTRIBUTION_URL: z
    .string()
    .min(1, "Missing media distribution url"),
  NEXT_PUBLIC_LOCATIONS_PHOTOS_DISTRIBUTION_URL: z
    .string()
    .min(1, "Missing locations photos distribution url"),
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z
    .string()
    .min(1, "Missing stripe publishable key"),
  NEXT_PUBLIC_RADARPUBLISHABLEKEY: z.string().min(1, "Missing Radar key"),
  NEXT_ADMIN_API_URL: z.string().min(1, "Missing NEXT_ADMIN_API_URL"),
  NEXT_AUTH_API_URL: z.string().min(1, "Missing NEXT_AUTH_API_URL"),
  NEXT_ARTICLES_API_URL: z.string().min(1, "Missing NEXT_ARTICLES_API_URL"),
  NEXT_CURRENCY_API_URL: z.string().min(1, "Missing NEXT_CURRENCY_API_URL"),
  NEXT_LISTINGS_API_URL: z.string().min(1, "Missing NEXT_LISTINGS_API_URL"),
  NEXT_LISTINGS_MANAGEMENT_API_URL: z
    .string()
    .min(1, "Missing NEXT_LISTINGS_MANAGEMENT_API_URL"),
  NEXT_SEARCH_API_URL: z.string().min(1, "Missing NEXT_SEARCH_API_URL"),
  NEXT_PROFILES_API_URL: z.string().min(1, "Missing NEXT_PROFILES_API_URL"),
  NEXT_PAYMENTS_API_URL: z.string().min(1, "Missing NEXT_PAYMENTS_API_URL"),
  NEXT_AGENCY_API_URL: z.string().min(1, "Missing NEXT_AGENCY_API_URL"),
  NEXT_SHARED_API_URL: z.string().min(1, "Missing NEXT_SHARED_API_URL"),
  NEXT_NOTIFICATIONS_API_URL: z
    .string()
    .min(1, "Missing NEXT_NOTIFICATIONS_API_URL"),
  NEXT_CHATS_API_URL: z.string().min(1, "Missing NEXT_CHATS_API_URL"),
  NEXT_CHATS_SOCKET_API_URL: z
    .string()
    .min(1, "Missing NEXT_CHATS_SOCKET_API_URL"),
  NEXT_DEFAULT_API_URL: z.string().min(1, "Missing NEXT_DEFAULT_API_URL"),
  NEXT_MAP_URL: z.string().min(1, "Missing NEXT_MAP_URL"),
  NEXT_COGNITO_CLIENT_ID: z.string().min(1, "Missing NEXT_COGNITO_CLIENT_ID"),
  NEXT_COGNITO_URL: z.string().min(1, "Missing NEXT_COGNITO_URL"),
  NEXT_PUBLIC_FORCE_SECURE: z
    .string()
    .min(1, "Missing NEXT_PUBLIC_FORCE_SECURE"),
  NEXT_NOTIFICATIONS_APPSYNC_WSS: z
    .string()
    .min(1, "Missing NEXT_NOTIFICATIONS_APPSYNC_WSS"),
  NEXT_NOTIFICATIONS_GRAPHQL_HOST: z
    .string()
    .min(1, "Missing NEXT_NOTIFICATIONS_GRAPHQL_HOST"),
});

const result = schema.safeParse(rawEnv);

if (!result.success) {
  console.error(
    "Invalid environment variables:",
    result.error.flatten().fieldErrors,
  );
  throw new Error("Environment variable validation failed.");
}

export const env = result.data;
